import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '@core/services/core/base.service';
import { BusinessLoginUserData } from '@models/business';

@Injectable({
  providedIn: 'root'
})
export class BusinessesLoginService {
  constructor(private http: HttpClient, private baseService: BaseService) {}

  confirmVerification(code: string) {
    const url = `${this.baseService.getAwsBaseUrl()}/metsintegration/email/verification/confirm`;
    const requestBody = { code };
    return this.http.post(url, requestBody);
  }

  sendVerification(userData: BusinessLoginUserData, modifyEmailData = false) {
    const url = `${this.baseService.getAwsBaseUrl()}/metsintegration/email/verification/send`;
    const requestBody = {
      email: userData.email,
      cif: userData.cif,
      nif: userData.nif,
      modifyEmailData
    };
    const headers = new HttpHeaders()
      .append('Authorization', userData.signedToken);
    return this.http.post(url, requestBody, { headers });
  }
}
